import React, {useEffect} from "react";
import {addStripeToHead, buildClientReferenceId, stripePriceTables} from "../../utils/stripe";
import Modal from "react-bootstrap/Modal";
import {concepts, Group, Subscription} from "fearless-common";
import Description from "../Description";
import StripePricingTable, {PRICING_TABLE_PRODUCT} from "../StripePricingTable";
import SubscriptionCard from "./SubscriptionCard";

export default function ManageGroupSubscriptionModal({ group, onClose }: {
  group: Group & { subscriptions: Subscription[] };
  onClose: () => void;
}) {
    useEffect(() => {
        addStripeToHead();
    }, []);

    return (
        <Modal onHide={onClose} show size={group.is_subscribed ? "lg" : "xl"} id="Manage group subscription">
            <Modal.Header closeButton>
                <Modal.Title>
                    {group.is_subscribed ? `Manage ${group.name} ${concepts.Subscription}` : 'Subscription options'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {Array.isArray(group?.subscriptions) && group?.subscriptions.map(sub => (
                    <SubscriptionCard
                      reloadSubscriptions={() => {
                        onClose();
                      }}
                      key={sub.id}
                      subscription={sub}
                      group={group}
                    />
                ))}
                {group && !group.is_subscribed && (
                    <>
                        <Description>
                            A {concepts.Subscription.toLowerCase()} enables all members to use {concepts.Photo51} both online and offline.
                        </Description>
                        <StripePricingTable
                            tableId={stripePriceTables.GROUP_ANNUAL}
                            clientReferenceId={buildClientReferenceId('group', group.id)}
                            groupId={group.id}
                            postPrices={[PRICING_TABLE_PRODUCT.INSTITUTE]}
                        />
                    </>
                )}
            </Modal.Body>
        </Modal>
    )
}
